import { initDayjs } from '~/astra'

import env from './env'

initDayjs({ today: env.VITE_TODAY })
